export const CONFIG = {
  title: 'Atelier Gascon',
  titleSuffix: ' - Atelier Gascon',

  description: 'Atelier Gascon',
};

/**
 * @typedef {Object} Locale
 * @property {string} title
 * @property {string} shortName
 * @property {string} locale
 * @property {string} shortCode
 * @property {string} pathPrefix
 */

/**
 * @type {Object<string, Locale>}
 */
export const LOCALE = {
  FR: {
    title: 'FRANÇAIS',
    shortName: 'FR',
    locale: 'fr-fr',
    shortCode: 'fr',
    pathPrefix: '/',
  },
};

/**
 * @type {Locale[]}
 */
export const LOCALES = [LOCALE.FR];

export const DEFAULT_LOCALE = LOCALES[0];
